import { PASSO_ESCADA_LABEL, PassoEscada, type EspecialidadeProf } from "../../types";
import { DISCIPLINA_CLASSE } from "../types";

/**
 * Escada de aproximação com REALCE DA ZONA da disciplina (Elo). A escada é a mesma
 * para todos — é uma régua de observação, não um método (§3 do estudo). Mas cada
 * disciplina destrava uma parte: TO 0–4, fono 5–9. Psico/nutri não "movem" um degrau
 * (a psico baixa o teto emocional; a nutri escolhe o alimento) — para elas, marcar o
 * degrau é opcional e o seletor deixa isso claro. Reusa as classes .escada do app.
 */
const PASSOS = Object.values(PassoEscada).filter(
  (v): v is PassoEscada => typeof v === "number",
);

/** Faixa de degraus que a disciplina destrava, ou null (atua no todo / escolhe o alvo). */
function zonaDe(esp: EspecialidadeProf): [number, number] | null {
  if (esp === "to") return [0, 4];
  if (esp === "fono") return [5, 9];
  return null;
}

const CAPTION: Record<EspecialidadeProf, string> = {
  to: "zona da TO: tolerar → cheirar (degraus 0–4). registre o que observou hoje.",
  fono: "zona da fono: levar à boca → comer a porção (degraus 5–9).",
  psico: "a psicologia atua no teto emocional, que rebaixa qualquer degrau — marcar é opcional.",
  nutri: "a nutrição escolhe o alimento; o degrau é referência da equipe — marcar é opcional.",
  medico: "o médico acompanha o quadro clínico; o degrau é referência da equipe — marcar é opcional.",
  outro: "marque o degrau observado hoje (opcional).",
};

export function EscadaDisciplina({
  especialidade,
  valor,
  onChange,
}: {
  especialidade: EspecialidadeProf;
  valor: PassoEscada | null;
  onChange: (p: PassoEscada) => void;
}) {
  const zona = zonaDe(especialidade);
  // DISCIPLINA_CLASSE[esp] = "disc-to" → token CSS "--disc-to"
  const corVar = `var(--${DISCIPLINA_CLASSE[especialidade]})`;

  return (
    <div>
      <p className="escada-zona-cap">{CAPTION[especialidade]}</p>
      <div className="escada" role="radiogroup" aria-label="degrau observado na escada">
        {PASSOS.map((p) => {
          const preenchido = valor !== null && p <= valor;
          const atual = valor === p;
          const naZona = zona !== null && p >= zona[0] && p <= zona[1];
          return (
            <button
              key={p}
              type="button"
              role="radio"
              aria-checked={atual}
              className={`escada-passo${preenchido ? " preenchido" : ""}${atual ? " atual" : ""}${naZona ? " na-zona" : ""}`}
              style={naZona ? { borderLeft: `4px solid ${corVar}` } : undefined}
              onClick={() => onChange(p)}
            >
              <span className="num" aria-hidden>
                {p}
              </span>
              <span>{PASSO_ESCADA_LABEL[p]}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
